import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import AdminUserManagement from '../../../components/siteadmin/AdminUserManagement';
import adminRolesQuery from './adminRolesQuery.graphql';
import adminUserQuery from './adminUserQuery.graphql';
import { withQuery } from '../../../hoc/withGraphql';
import s from './AdminUser.css';
class AdminUser extends React.Component {

  static propTypes = {
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getAllAdminRoles: PropTypes.array,
    })
  };

  static defaultProps = {
    data: {
      loading: true
    },
    adminRoles: {
      getAllAdminRoles: []
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1
    }
  }

  setStateVariable = (variables) => {
    this.setState(variables);
  }

  render() {
    const { currentPage } = this.state;

    return <AdminUserManagement
      setStateVariable={this.setStateVariable}
      currentPage={currentPage} />
  }
}

export default compose(
  withStyles(s),
  withQuery(adminUserQuery, {
    options: (props) => ({
      variables: {
        currentPage: props.currentPage
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  }),
  withQuery(adminRolesQuery, {
    name: 'adminRoles',
    options: {
      fetchPolicy: 'network-only',
      ssr: false
    }
  })
)(AdminUser);
